export default "/_next/static/images/prefill-full-d50f112bc6373a4160c08a9060f21c34.png";